import BlockSettings from "app/blocks/models/block-settings.interface";

export default (settings: BlockSettings): string[] => {
    const classes = [];

    // Padding Top

    if (settings?.paddingTop) {
        classes.push(`padding-top--${settings.paddingTop}`);
    }
    else {
        classes.push("padding-top--Medium");
    }

    // Padding Bottom

    if (settings?.paddingBottom) {
        classes.push(`padding-bottom--${settings.paddingBottom}`);
    }
    else {
        classes.push("padding-bottom--Medium");
    }

    // Margin Top

    if (settings?.marginTop && settings?.marginTop !== "None") {
        classes.push(`margin-top--${settings.marginTop}`);
    }

    // Margin Bottom

    if (settings?.marginBottom && settings?.marginTop !== "None") {
        classes.push(`margin-bottom--${settings.marginBottom}`);
    }

    // Border

    if (settings?.showBorderTop && settings.showBorderBottom) {
        classes.push("border-both");
    }
    else if (settings?.showBorderTop) {
        classes.push("border-top");
    }
    else if (settings?.showBorderBottom) {
        classes.push("border-bottom");
    }

    return classes;
};
